import { Box, Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export const NoLessonsFound = styled(Box)(() => ({
  textAlign: 'center',
  userSelect: 'none',
}));
